// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"338":"ddfcb49a","376":"46dd8a99","448":"46dd8a99","568":"400695e8","919":"ddfcb49a"}[chunkId] + ".chunk.css";
};